import moment from 'moment-timezone';

const staticDateEnd = '07/01/2025';
const formattedStaticDateEnd = moment(staticDateEnd).format('MMMM Do YYYY');

export { formattedStaticDateEnd, staticDateEnd };
